import { post } from "../api.helper";
import * as URL from "../url.helper";

export const resetPassword = data => post(URL.RESET_PASSWORD, data, {skipInterceptor: true});

export const forgetPassword = data => post(URL.FORGET_PASSWORD, data, {skipInterceptor: true})